// do not use boolean values (e.g., "on"/"off" rather than true/false)

function toBoolean(value) {
    const normalized = value.trim().toLowerCase();
    if (normalized === "true") return true;
    if (normalized === "false") return false;
}

export default {
    KRAKEN_GETTING_STARTED_URL:'https://scalecomputing.github.io/kraken-applications/getting-started/overview/',
    KRAKEN_EXAMPLE_URL: 'https://scalecomputing.github.io/kraken-applications/examples/basic/',
    KRAKEN_SCHEMA_URL: 'https://scalecomputing.github.io/kraken-applications/spec/overview/',
    KRAKEN_DOCS_URL: 'https://scalecomputing.github.io/kraken-applications/',
    VUE_APP_NUCLEUS_API: process.env.VUE_APP_NUCLEUS_API ?? '{{VUE_APP_NUCLEUS_API}}',
    VUE_APP_GOOGLE_ANALYTICS_ID: process.env.VUE_APP_GOOGLE_ANALYTICS_ID ?? '{{VUE_APP_GOOGLE_ANALYTICS_ID}}',
    VUE_APP_HOTJAR_ID: process.env.VUE_APP_HOTJAR_ID ?? '{{VUE_APP_HOTJAR_ID}}',
    VUE_APP_TUNNEL_DOMAIN: process.env.VUE_APP_TUNNEL_DOMAIN ?? '{{VUE_APP_TUNNEL_DOMAIN}}',
    SCALE_SUPPORT_URL: 'https://www.scalecomputing.com/support',
    VUE_APP_CLUSTER_LIST_REFRESH_INTERVAL_MS: process.env.VUE_APP_CLUSTER_LIST_REFRESH_INTERVAL_MS || '{{VUE_APP_CLUSTER_LIST_REFRESH_INTERVAL_MS}}',
    VUE_APP_RAYGUN_API_KEY: process.env.VUE_APP_RAYGUN_API_KEY || '{{VUE_APP_RAYGUN_API_KEY}}',
    VUE_APP_STATSIG_API_KEY: process.env.VUE_APP_STATSIG_API_KEY || '{{VUE_APP_STATSIG_API_KEY}}',
    VUE_APP_ENABLE_ALL_FEATURES: process.env.VUE_APP_ENABLE_ALL_FEATURES ?? '{{VUE_APP_ENABLE_ALL_FEATURES}}',
    VUE_APP_ENV: process.env.VUE_APP_ENV ?? '{{VUE_APP_ENV}}',
    // Recaptcha Config
    VUE_APP_RECAPTCHA_SITE_KEY: process.env.VUE_APP_RECAPTCHA_SITE_KEY ?? '{{VUE_APP_RECAPTCHA_SITE_KEY}}',
    // Firebase config
    VUE_APP_FIREBASE_API_KEY: process.env.VUE_APP_FIREBASE_API_KEY ?? '{{VUE_APP_FIREBASE_API_KEY}}',
    VUE_APP_FIREBASE_AUTH_DOMAIN: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN ?? '{{VUE_APP_FIREBASE_AUTH_DOMAIN}}',
    VUE_APP_FIREBASE_PROJECT_ID: process.env.VUE_APP_FIREBASE_PROJECT_ID ?? '{{VUE_APP_FIREBASE_PROJECT_ID}}',
    VUE_APP_FIREBASE_STORAGE_BUCKET: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET ?? '{{VUE_APP_FIREBASE_STORAGE_BUCKET}}',
    VUE_APP_FIREBASE_MESSAGING_SENDER_ID: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID ?? '{{VUE_APP_FIREBASE_MESSAGING_SENDER_ID}}',
    VUE_APP_FIREBASE_APP_ID: process.env.VUE_APP_FIREBASE_APP_ID ?? '{{VUE_APP_FIREBASE_APP_ID}}',
    VUE_APP_FIREBASE_MEASUREMENT_ID: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID ?? '{{VUE_APP_FIREBASE_MEASUREMENT_ID}}',
    VUE_APP_FIREBASE_APPCHECK_DEBUG_TOKEN: process.env.VUE_APP_FIREBASE_APPCHECK_DEBUG_TOKEN ?? '{{VUE_APP_FIREBASE_APPCHECK_DEBUG_TOKEN}}',
    VUE_APP_REPLACE_SSO_WITH_TOKEN: toBoolean(process.env.VUE_APP_REPLACE_SSO_WITH_TOKEN ?? '{{VUE_APP_REPLACE_SSO_WITH_TOKEN}}'),
    VUE_APP_SALESFORCE_URL: process.env.VUE_APP_SALESFORCE_URL ?? '{{VUE_APP_SALESFORCE_URL}}',
    VUE_APP_NOTIFICATIONS_FROM_EMAIL: process.env.VUE_APP_NOTIFICATIONS_FROM_EMAIL ?? '{{VUE_APP_NOTIFICATIONS_FROM_EMAIL}}',
};
